import {useEffect, useState} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {AxiosError} from 'axios'
import * as bootstrap from 'bootstrap'
import Select from 'react-select'
import {getUserList, saveDeviceUser} from '../../../../modules/auth/core/_requests'
import {KTSVG} from '../../../../../_metronic/helpers'
import {SuccessfulNotify, UnsuccessfulNotify} from '../../../../../ToastMetods'

const profileDetailsSchema = Yup.object().shape({
  deviceUser: Yup.number().required('Device type is required'),
})

function CreateUserForm({itemId, setAction}: any) {
  const [deviceUser, setDeviveUser] = useState([])
  useEffect(() => {
    getList()
  }, [])

  const getList = async () => {
    try {
      const {data} = await getUserList('', '', 0, 0, '', true, true)
      setDeviveUser(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const initialValues = {
    deviceUser: 0,
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: async (values, {resetForm}) => {
      try {
        await saveDeviceUser(itemId, values.deviceUser)
        setAction(true)
        resetForm()
        //Modal close
        const modal = bootstrap.Modal.getOrCreateInstance('#createTabContentUser_modal')
        modal.hide()
        //
        SuccessfulNotify('Registration Successfully Added.')
      } catch (err) {
        const error = `${(err as AxiosError)?.response?.data}`
        console.error(error)
        UnsuccessfulNotify(String(error))
      }
    },
  })

  const optionDeviceUserList = deviceUser.map((item: any) => ({
    value: item.id,
    label: String(item.fullName),
  }))

  return (
    <div className='modal fade' tabIndex={-1} id={`createTabContentUser_modal`}>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Create User</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <form onSubmit={formik.handleSubmit} noValidate className='form'>
              <div className='modal-body'>
                {/*From*/}

                <div className='mb-10'>
                  <label className='form-label'>Device User</label>
                  <Select
                    options={optionDeviceUserList}
                    placeholder='Select Device User'
                    onChange={(e) => formik.setFieldValue('deviceUser', Number(e?.value))}
                    value={optionDeviceUserList.filter(
                      (item) => item.value === formik.getFieldProps('deviceUser').value
                    )}
                  />
                  {/*<select
                    className='form-select'
                    aria-label='Select example'
                    {...formik.getFieldProps('deviceUser')}
                  >
                    <option>Open this select menu</option>
                    {deviceUser.map((item: any) => (
                      <option key={item.id} value={item.id}>
                        {item.fullName}
                      </option>
                    ))}
                  </select>*/}
                  {formik.touched.deviceUser && formik.errors.deviceUser && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.deviceUser}</div>
                    </div>
                  )}
                </div>

                {/*End Form */}
              </div>
              <div className='modal-footer'>
                <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                  Close
                </button>

                <button type='submit' className='btn btn-primary'>
                  Create User
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateUserForm
